import React, { useLayoutEffect, useRef, useState } from 'react';
import { topBarOverlap, topBarNodes } from '../../utils/topBar';

/**
 * The navbar's spacer, SIZED FROM THE MEASURED BAR (fix batch 33, R11 —
 * Fable, 2026-10-07, Cowork run 31: "~65px of empty white between the
 * navbar and the first content on every console page").
 *
 * It was `<div style={{ marginTop: '80px' }}>` "for a fixed navbar". The
 * navbar is `position: sticky` — IN FLOW — so `<main>` already begins under
 * it, and the 80px was a band sized for a bar the app does not draw. The
 * height here is `topBarOverlap`: how much of a top bar covers the point
 * where the page's content begins (0 for the sticky bar; the bar's own
 * height for a fixed one), read through the SAME measurement the FroggerAI
 * dock uses (`utils/topBar`), never a constant. Re-measured when the bar
 * resizes (the logo shrinks at the phone breakpoints) and on window resize.
 */
export default function NavbarSpacer() {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      const next = topBarOverlap(ref.current);
      setHeight((prev) => (prev === next ? prev : next));
    };
    measure();
    window.addEventListener('resize', measure);
    let observer = null;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(measure);
      topBarNodes().forEach((node) => observer.observe(node));
    }
    return () => {
      window.removeEventListener('resize', measure);
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={ref}
      className="ff-navbar-spacer"
      data-navbar-spacer={height}
      style={{ height: `${height}px` }}
    />
  );
}
